import { createSlice } from '@reduxjs/toolkit';

import { HighRiskSupplementDetails } from '@models/highRiskSupplementDetails';

import { handleGetHighRiskSupplementDetails } from './actions';
import { IHighRiskSupplementsDetailsState } from './slice.interface';

const initialState: IHighRiskSupplementsDetailsState = {
  activeEntryId: null,
  data: null,
  isLoading: false,
  error: false,
};

export const highRiskSupplementDetailsSlice = createSlice({
  name: 'high-risk-supplement-details',
  initialState,
  reducers: {
    removeHighRiskSupplementsDetails: state => {
      state.activeEntryId = null;
      state.data = null;
      state.isLoading = false;
      state.error = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(
        handleGetHighRiskSupplementDetails.pending,
        (state: IHighRiskSupplementsDetailsState, action) => {
          state.activeEntryId = action.meta.arg;
          state.isLoading = true;
          state.error = false;
        },
      )
      .addCase(
        handleGetHighRiskSupplementDetails.rejected,
        (state: IHighRiskSupplementsDetailsState, action) => {
          state.isLoading = false;
          state.error = true;
        },
      )
      .addCase(
        handleGetHighRiskSupplementDetails.fulfilled,
        (state: IHighRiskSupplementsDetailsState, action) => {
          state.isLoading = false;
          state.data = new HighRiskSupplementDetails(action?.payload?.data);
        },
      );
  },
});

export const { removeHighRiskSupplementsDetails } = highRiskSupplementDetailsSlice.actions;

export default highRiskSupplementDetailsSlice.reducer;
